import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { serverUrl } from '../../../Constant/Static/config';
import DeleteIcon from '../../../Constant/Icons/delete.svg';
import editIcon from '../../../Constant/Icons/edit.svg';
import saveIcon from '../../../Constant/Icons/save.svg';
import cancelIcon from '../../../Constant/Icons/cancel.svg';
import addIcon from '../../../Constant/Icons/addItem.svg';

function HandleNotification() {
    const [notifications, setNotifications] = useState([]);
    const [newNotification, setNewNotification] = useState('');
    const [editId, setEditId] = useState(null);
    const [editNotification, setEditNotification] = useState('');

    const fetchNotifications = async () => {
        try {
            const response = await axios.get(`${serverUrl}/api/admin/services/notifications`); // Adjust the path if necessary
            setNotifications(response.data);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };

    const handleAddNotification = async () => {
        try {
            const response = await axios.post(`${serverUrl}/api/admin/services/notifications`, { message: newNotification });
            setNotifications([...notifications, response.data]);
            setNewNotification('');
        } catch (error) {
            console.error('Error adding notification:', error);
        }
    };

    const handleEditNotification = (id, message) => {
        setEditId(id);
        setEditNotification(message);
    };

    const handleUpdateNotification = async () => {
        try {
            const response = await axios.put(`${serverUrl}/api/admin/services/notifications/${editId}`, { message: editNotification });
            setNotifications(notifications.map(n => (n.id === editId ? response.data : n)));
            setEditId(null);
            setEditNotification('');
        } catch (error) {
            console.error('Error updating notification:', error);
        }
    };

    const handleDeleteNotification = async (id) => {
        try {
            await axios.delete(`${serverUrl}/api/admin/services/notifications/${id}`);
            setNotifications(notifications.filter(n => n.id !== id));
        } catch (error) {
            console.error('Error deleting notification:', error);
        }
    };

    useEffect(() => {
        fetchNotifications();
    }, []);

    return (
        <div className="notification-admin-container">
            <h2>Manage Notifications</h2>
            <div style={{ width: '90%' }}>
                <ul className="notification-list">
                    {notifications.map((notification) => (
                        <li key={notification.id} className="notification-item">
                            {editId === notification.id ? (
                                <div className="edit-mode">
                                    <div>
                                        <input
                                            type="text"
                                            value={editNotification}
                                            onChange={(e) => setEditNotification(e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <button className="button" onClick={handleUpdateNotification}><img src={saveIcon} alt='edit' width={20} height={20} /></button>
                                        <button className="button" onClick={() => setEditId(null)}><img src={cancelIcon} alt='edit' width={20} height={20} /></button>
                                    </div>
                                </div>
                            ) : (
                                <div className="notification-content">
                                    <span className="notification-message">
                                        {notification.message.length > 30 ? `${notification.message.slice(0, 30)}...` : notification.message}
                                    </span>
                                    <div className="button-group">
                                        <button className="button" onClick={() => handleEditNotification(notification.id, notification.message)}>
                                            <img src={editIcon} alt='edit' width={20} height={20} />
                                        </button>
                                        <button className="button" onClick={() => handleDeleteNotification(notification.id)}>
                                            <img src={DeleteIcon} alt='delete' width={20} height={20} />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
            <div className="input-container">
                <input
                    type="text"
                    value={newNotification}
                    onChange={(e) => setNewNotification(e.target.value)}
                    placeholder="New notification"
                />
                <button className="button" onClick={handleAddNotification}>
                    <img src={addIcon} alt='edit' width={25} height={25} /><span>&ensp;Add</span>
                </button>
            </div>
        </div>
    );
}

export default HandleNotification;
